export default "__VITE_ASSET__0c25d96a__"